import { DoLogin, DoLogout } from './actions';

export default {
  namespaced: true,
  state: {
    userToken: '',
    fullName: '',
    client: {},
    availableClients: [],
    accessLevel: {},
    tokenAuth: '',
    socket: null,
  },
  getters: {
    getLoggedUser: state => {
      return state.user;
    },
    getUserToken: state => {
      return state.userToken;
    },
    getSocket: state => {
      return state.socket;
    },
    fullName: state => state.fullName,
    tokenAuth: state => state.tokenAuth,
    client: state => state.client,
    availableClients: state => state.availableClients,
    accessLevel: state => state.accessLevel,
    HasAccess: state => (sectorId, action) => {
      const haveSector = state.accessLevel[sectorId] || [];
      const hasAction = haveSector.includes(action);
      const hasAll = haveSector.includes('ALL');
      return hasAction || hasAll;
    },
    canChangeClient: state => state.availableClients.length > 1,
  },
  mutations: {
    setAccessData: (
      state,
      { userToken, fullName, role, client, availableClients },
    ) => {
      state.userToken = userToken;
      state.fullName = fullName;
      state.accessLevel = role ? role.permissions : null;
      state.client = client;
      state.availableClients = availableClients;
    },
    setUserToken: (state, token) => {
      state.userToken = token;
    },
    setToken: (state, { token }) => {
      state.tokenAuth = token;
    },
    setSocket: (state, socket) => {
      state.socket = socket;
    },
  },
  actions: {
    doLogin: DoLogin,
    doLogout: DoLogout
  },
};
